import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  /* uikit's own ResetCSS sets a universal '* { font-family: Kanit }' rule with equal
     specificity - !important is the only reliable way to override it regardless of
     styled-components' injection order. */
  * {
    font-family: 'Inter', sans-serif !important;
  }

  body {
    background-color: ${({ theme }) => theme.colors.background};

    img {
      height: auto;
      max-width: 100%;
    }
  }

  button, a {
    transition: transform 150ms ease, opacity 150ms ease, background-color 150ms ease, box-shadow 150ms ease;
  }
  button:active {
    transform: scale(0.97);
  }

  /* uikit's compiled Button/IconButton/Input only style plain ':focus' (which also fires on
     mouse clicks). Layer a keyboard-only ring on top via ':focus-visible' so pointer users
     don't see it but keyboard/AT users always get a visible, high-contrast focus indicator. */
  button:focus-visible,
  a:focus-visible,
  input:focus-visible,
  [role="button"]:focus-visible,
  [tabindex]:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.secondary};
    outline-offset: 2px;
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }

  /* @pancakeswap-libs/uikit's <Menu> bakes its bunny logo into the compiled
     bundle with no prop/slot to override it - targeting its stable aria-label
     (not an internal class name) to paint the real Libera logo over it instead. */
  [aria-label="Pancake home page"] {
    background-image: url('/images/libera-logo.png');
    background-size: 40px 40px;
    background-repeat: no-repeat;
    background-position: left center;
    padding-left: 48px;
    display: flex;
    align-items: center;
  }
  [aria-label="Pancake home page"] svg {
    visibility: hidden;
    width: 0;
  }
  [aria-label="Pancake home page"]::after {
    content: 'LiberaDex';
    font-weight: 600;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.text};
    white-space: nowrap;
  }
`

export default GlobalStyle
